module.exports = __webpack_public_path__ + "static/media/abouticon2.42fb12a4.png";